import React from "react";
import { Form, Input, Space, Button, message, Radio } from "antd";
import baseRequest from "../../utils/baseRequest";

const RefundContent = (props) => {
  const [form] = Form.useForm();

  //提交退款
  const handleRefund = async (value) => {
    try {
      const base = baseRequest();
      const _response = await fetch(
        `/op/vas/${
          value.type === "coin" ? "refund_coin_order" : "refund_order"
        }`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            order_id: value.orderId,
            operator: value.operator,
            ...base,
          }),
        }
      );
      const _data = await _response.json();
      console.log(_data);
      if (_data.ret === -1) {
        alert(_data.msg);
        return;
      }
      form.resetFields();
      message.success("退款成功");
    } catch (error) {
      console.error(error);
    }
  };
  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="mt-4" style={{ marginLeft: 20, marginRight: 20 }}>
      <Form
        name="refund"
        form={form}
        onFinish={handleRefund}
        onFinishFailed={onFinishFailed}
      >
        <Space direction="vertical" style={{ marginBottom: 20 }}>
          <Form.Item label="订单号" name="orderId" style={{ margin: 0 }}>
            <Input type="number" />
          </Form.Item>
          <Form.Item label="操作人" name="operator" style={{ margin: 0 }}>
            <Input type="text" />
          </Form.Item>
          <Form.Item
            label=""
            name="type"
            rules={[
              {
                required: true,
                message: "未选择",
              },
            ]}
            style={{ margin: 0 }}
          >
            <Radio.Group>
              <Radio.Button value="coin">退金币</Radio.Button>
              <Radio.Button value="cash">退现金</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Button type="primary" htmlType="submit">
            确认退款
          </Button>
        </Space>
      </Form>
    </div>
  );
};

export default function Refund() {
  return <RefundContent />;
}
